import { Modal } from '../common/Modal';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message?: string;
  actionLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({ open, title = 'Cancel Visit', message = 'Cancel this visit? The patient will be notified.', actionLabel = 'Cancel Visit', onConfirm, onCancel }: ConfirmModalProps) {
  return (
    <Modal open={open} onClose={onCancel} maxWidth="360px">
      <h3 className="mb-1">{title}</h3>
      <p className="text-sm text-muted mb-2">{message}</p>
      <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
        <button className="btn btn--outline btn--sm" onClick={onCancel}>Go Back</button>
        <button className="btn btn--sm" style={{ background: 'var(--error-color)', color: '#fff', borderColor: 'var(--error-color)' }} onClick={onConfirm}>{actionLabel}</button>
      </div>
    </Modal>
  );
}
